import styled from 'styled-components'

const SmallParagraph = styled.p`
  font-size: 14px;
  font-family: "Roboto",Helvetica,Arial,sans-serif;
  color: #6F6F6F;
`

export default SmallParagraph
